

export const pdfMobilityCutExamples = [
  {
    name: {
      en: "Mobility cut - EXAMPLE",
      fr: "Coupe de mobilité - EXEMPLE",
      nl: "Mobiliteitsdoorsnede - VOORBEELD"
    },
    url: {
      en: "/pdf/MOBILITY_CUT/mobility_cut_example_EN.pdf",
      fr: "/pdf/MOBILITY_CUT/mobility_cut_example_FR.pdf",
      nl: "/pdf/MOBILITY_CUT/mobility_cut_example_NL.pdf",
    }
  }
];
